//ProductForm.jsx
import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../shadcn/ui/dialog";
import ProductBasicInfo from './ProductBasicInfo';
import SeoMetaDetails from './SeoMetaDetails.jsx';
import MediaDialog from './MediaDialog';

const ProductForm = ({
    isOpenProductForm,
    onCloseProductForm,
    onSaveBasicInfo,
    onSubmitBasicInfo,
    onSaveSeoMeta,
    onSaveKeywords,
    initialValues,
    parentId,
    categoryOptions = [],
    defaultCategoryId = '',
    onOpenCategoryPanel = () => {},
}) => {
    return (
        <Dialog open={isOpenProductForm} onOpenChange={onCloseProductForm}>
            <DialogContent className="sm:max-w-[80vw] sm:max-h-[80vh] w-full h-full overflow-auto pb-20">
                <DialogHeader>
                    {parentId == '1' ?
                    <DialogTitle>{initialValues ? 'Επεξεργασία ποικιλίας' : 'Νέα ποικιλία'}</DialogTitle>
                    : <DialogTitle>{initialValues ? 'Επεξεργασία εξοπλισμού' : 'Νέο εξοπλισμό'}</DialogTitle> }
                </DialogHeader>
                <div>

                    <ProductBasicInfo
                        initialValues={initialValues}
                        onSaveBasicInfo={onSaveBasicInfo}
                        parentId={parentId}
                        categoryOptions={categoryOptions}
                        defaultCategoryId={defaultCategoryId}
                        onOpenCategoryPanel={onOpenCategoryPanel}
                    />
                    {/* {initialValues && initialValues.product_id ? (
                    <SeoMetaDetails
                        initialValues={initialValues}
                        onSaveSeoMeta={onSaveSeoMeta}
                    />) : <p>Save {isBlend ? 'blend' : 'product' } to add SEO meta data.</p>} */}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ProductForm;
